<script setup lang="ts">
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'

import type { useServiceStore } from '@/stores/service.store.ts'

const { t } = useI18n()
const serviceStore = inject<ReturnType<typeof useServiceStore>>('serviceStore')

const logout = async (): Promise<void> => {
  if (serviceStore?.authService) {
    await serviceStore.authService.logout()
  }
}
</script>

<template>
  <v-container class="py-10">
    <v-card max-width="480" class="mx-auto pa-6">
      <v-card-title class="text-h5">
        {{ t('accessDenied.title') }}
      </v-card-title>
      <v-card-text>
        {{ t('accessDenied.message') }}
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="serviceStore"
          color="primary"
          @click="logout"
        >
          {{ t('accessDenied.backToLogin') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
